
import {Toast} from 'vant'
import qs from 'qs'

export default {
  name: 'addImages',
  data() {
    return {
      width: 0,
      number: 0,
      selectImg: [],
      materia: [],
      show: false,
      tabbar: [],
      groupingName: '',
      activeKey: 0,
      materialList: [],
      allmaterialList: [],
      index: 0,
      isHasMore: true,
      isLoading: false,
      checked: '',
      id: 0,
      show1: true,
      FolderIndex: 0,
      msg: this.$t('append_field.loadingb'),
      radio: ""
    }
  },
  mounted() {
    this.width = document.getElementById('materiallists').clientWidth / 4 - 2
    this.getFolder(0)
    const materiallist = document.getElementsByClassName('abcds')[0]
    materiallist.addEventListener('scroll', this.handleScroll)
    this.selectImg = []
  },
  methods: {
    getFolder(index) {
      this.msg = this.$t('append_field.loadingb')
      const p = new Promise((resolve, reject) => {
        this.$ajax.post('/etv/findAllOrOneFolder.json', qs.stringify({
          mtType: 'img',
          type: 'select',
          id: '',
          filterType:1
        })).then(res => {
          if (res.data.code === 0) {
            localStorage.setItem("lastSize",res.data.data.lastSize)
            resolve(res.data.data)
          } else {
            reject()
          }
        })
      })
      p.then(res => {
        this.tabbar = res.children

        this.groupingName = this.tabbar[index].name
        this.id = this.tabbar[index].mfId

        this.getmaterial(this.id)
      })
    },
    close() {
      this.$emit('close')
    },
    submits() {
      if (this.selectImg.length === 0) {
        Toast(this.$t('append_field.selectImage'))
        return
      }
      this.$emit('setImages', this.selectImg)
    },
    upImage() {
    },
    Drawer() {
      this.show = true
    },
    onChange(index) {
      this.FolderIndex = index
      this.materialList = []
      this.groupingName = this.tabbar[index].name
      this.getmaterial(this.tabbar[index].mfId)
      this.id = this.tabbar[index].mfId
      this.show = false
      this.show1 = true
    },
    getmaterial(id) {
      this.$ajax.post('/etv/findAllMaterial.json', qs.stringify({
        id,
        type: 'img',
        pageNum: 1,
        pageSize: 99999,
        filterType:1
      })).then(res => {
        if (res.data.code === 0) {
          this.number =0
          this.allmaterialList = res.data.data.materialList
          this.allmaterialList.map(res => {
            res.checked = false
          })
          this.materialList = this.allmaterialList.slice(this.index, this.index + 28)
          this.$nextTick(() => {
            this.show1 = false
          })
        }
      })
    },
    handleScroll() {
      //滚动条
      const scrollHeight = document.getElementsByClassName('abcds')[0].scrollTop
      let clientHeight = document.getElementsByClassName('content')[0].clientHeight
      let doch = window.screen.height
      //真实高度
      if (clientHeight - doch - scrollHeight < 40) {
        if (this.allmaterialList.slice(this.index * 28, this.index * 28 + 28).length < 28) {
          return
        }
        this.index++
        this.materialList = [...new Set([...this.materialList, ...this.allmaterialList.slice(this.index * 28, this.index * 28 + 28)])]
      }
    },
    getselevt(index) {
      this.radio = index
      this.selectImg = [this.materialList[index]]
    },
    afterRead(file) {

      const imgTypes = ['png', 'jpg', 'jpeg', 'gif']
      if (imgTypes.includes(file.file.name.split('.')[file.file.name.split('.').length - 1].toLowerCase())) {
        this.show1 = true
        this.msg = this.$t('append_field.uploading')
        const frromData = new FormData()
        frromData.append('files', file.file)
        frromData.append('id', this.id)
        this.$ajax.post(this.upFileUrl + 'etv/insertMaterial.json', frromData, {
          headers: {
            'contentType': 'multipart/form-data',
          },
        }).then(res => {
          if (res.data.code === 0) {
            Toast(res.data.msg)
            this.materialList = []
            this.getFolder(this.FolderIndex)
          } else {
            Toast(res.data.msg)
          }
        })
      } else {
        Toast(this.$t('append_field.imageFormatError'))
      }
    },
  },
  destroyed() {
    this.materialList = []
  },
}
